<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0" cols="12">
            <v-card class="mb-2 background-2 round-card" ref="notificationssetting">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Impostazioni</p>
                    <v-spacer></v-spacer>
                </v-card-title> 
                <v-divider></v-divider>
                <v-subheader class="pl-4">Invio Summary Timecard</v-subheader>
                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox 
                            color="primary" 
                            hide-details
                            v-model="settings['notify_summary_timecard']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Invia Mail con il ripilogo delle Timecard</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['notify_summary_timecard']">
                        <v-list-item>
                            <v-list-item-action>
                            </v-list-item-action>
                                <v-slide-y-transition>
                                    <v-row>
                                        <v-col class="px-4" cols="12" md="6" lg="4">
                                            <v-combobox
                                                name="Indirizzo mail CC"
                                                label="Indirizzo mail CC"
                                                small-chips
                                                combobox
                                                dense
                                                outlined
                                                clearable
                                                multiple
                                                v-model="settings['notify_summary_timecard_cc']"
                                                :error-messages="errors.collect('Indirizzo mail CC')"
                                                v-validate="'email'"
                                                :data-vv-name="'Indirizzo mail'"
                                            ></v-combobox>
                                        </v-col>
                                    </v-row>
                                </v-slide-y-transition>
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>                

                <v-subheader class="pl-4">Seleziona i giorni della settimana in cui inviare il Summary</v-subheader>

                <v-list class="background-2 px-2 py-0">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['notify_summary_timecard_days']" value="monday"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Lunedì</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>                
                </v-list>
                <v-list class="background-2 px-2 py-0">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['notify_summary_timecard_days']" value="tuesday"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Martedì</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>                
                </v-list>
                <v-list class="background-2 px-2 py-0">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['notify_summary_timecard_days']" value="wednesday"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Mercoledì</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>                
                </v-list>
                <v-list class="background-2 px-2 py-0">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['notify_summary_timecard_days']" value="thursday"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Giovedì</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>                
                </v-list>
                <v-list class="background-2 px-2 py-0">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['notify_summary_timecard_days']" value="friday"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Venerdì</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>                
                </v-list>
                <v-list class="background-2 px-2 py-0">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['notify_summary_timecard_days']" value="saturday"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Sabato</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>                
                </v-list>
                <v-list class="background-2 px-2 py-0">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['notify_summary_timecard_days']" value="sunday"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Domenica</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>                
                </v-list>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
					<v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import Vue from 'vue'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin';

    export default {
        name: 'timecards-options',
        mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'timecard',
                settings: {
                    'notify_summary_timecard': false,
                    'notify_summary_timecard_days': [],
                    'notify_summary_timecard_cc': null
                },
            }
        },


        created() {
            this.axios.get('settings/'+this.model).then(response => {

                _.forEach(response.data.settings, (setting) => {
                    Vue.set(this.settings, setting.key, setting.value)
                })

            }, response => {
                // error callback
            })
        }

    }
</script>